import React from 'react'
import { createUseStyles } from 'react-jss'
import { colors } from '../../../theme/palette'

interface BadgeProps {
    children: React.ReactNode
    color?: string
    backgroundColor?: string
}

const useStyles = createUseStyles(() => ({
    row: {
        backgroundColor: 'rgba(41, 122, 113, 0.1)',
        width: 'fit-content',
        color: colors.green500,
        display: 'flex',
        borderRadius: '4px',
        padding: '0.219rem 0.625rem',
        fontSize: '0.875rem',
    },
}))

const Badge: React.FC<BadgeProps> = ({ children, color, backgroundColor }) => {
    const classes = useStyles()
    const style = {
        ...(color && { color }),
        ...(backgroundColor && { backgroundColor }),
    }

    return (
        <div className={classes.row} style={style}>
            {children}
        </div>
    )
}

export { Badge }
